import { useNavigate } from "react-router-dom";

/**
 * BlogCard – reusable card component for the blog listing grid.
 * Supports skeleton mode for loading states.
 */
const BlogCard = ({ blog, skeleton = false ,isAdmin , onDelete }) => {
  const navigate = useNavigate();

  /* ── SKELETON ── */
  if (skeleton) {
    return (
      <div className="rounded-3xl overflow-hidden bg-white border border-gray-100 shadow-sm animate-pulse">
        <div className="h-52 bg-gray-200 w-full" />
        <div className="p-6 space-y-3">
          <div className="h-3 bg-gray-200 rounded w-1/3" />
          <div className="h-5 bg-gray-200 rounded w-4/5" />
          <div className="h-4 bg-gray-200 rounded w-full" />
          <div className="h-4 bg-gray-200 rounded w-2/3" />
          <div className="h-4 bg-gray-100 rounded w-1/4 mt-2" />
        </div>
      </div>
    );
  }

  const formattedDate = blog?.publishedAt
    ? new Date(blog.publishedAt).toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
      })
    : "";

  return (
    <button
      onClick={() => navigate(`/blogs/${blog.slug}`)}
      className="text-left group bg-white rounded-3xl border border-gray-100
                 shadow-sm hover:shadow-xl overflow-hidden
                 hover:-translate-y-1.5 transition-all duration-300 ease-out
                 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#5b6f00]/40"
    >
      {/* ── IMAGE ── */}
      <div className="relative h-52 overflow-hidden bg-gray-100">
        {blog.cover ? (
          <>
            <img
              src={blog.cover}
              alt={blog.title}
              className="h-full w-full object-cover group-hover:scale-105
                         transition-transform duration-500 ease-out"
            />
            {/* gradient overlay */}
            <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent" />
          </>
        ) : (
          <div className="h-full w-full bg-gradient-to-br from-[#5b6f00]/10 to-[#5b6f00]/20 flex items-center justify-center">
            <span className="text-4xl opacity-30">✍️</span>
          </div>
        )}
      </div>{isAdmin && (
  <div className="absolute top-3 right-3 flex gap-2 z-10">
    
    {/* EDIT */}
    <button
      onClick={(e) => {
        e.stopPropagation();
        window.location.href = `/blogs/admin/edit/${blog._id}`;
      }}
      className="px-2 py-1 text-xs bg-white/90 backdrop-blur rounded-md border border-gray-200 hover:bg-gray-100"
    >
      ✏️
    </button>

    {/* DELETE */}
    <button
      onClick={(e) => {
        e.stopPropagation();
        onDelete(blog._id);
      }}
      className="px-2 py-1 text-xs bg-red-500 text-white rounded-md hover:bg-red-600"
    >
      🗑
    </button>

  </div>
)}

      {/* ── CONTENT ── */}
      <div className="p-6 space-y-3">
        {/* Meta */}
        <p className="text-xs text-gray-400 font-medium tracking-wide uppercase">
          {formattedDate}
          {blog.readTime && <span> &nbsp;·&nbsp; {blog.readTime}</span>}
        </p>

        {/* Title */}
        <h2 className="text-[1.1rem] font-bold text-gray-900 leading-snug
                        group-hover:text-[#5b6f00] transition-colors duration-200
                        line-clamp-2">
          {blog.title}
        </h2>

        {/* Excerpt */}
        {blog.excerpt && (
          <p className="text-sm text-gray-500 leading-relaxed line-clamp-2">
            {blog.excerpt}
          </p>
        )}
        

        {/* CTA */}
        <span className="inline-flex items-center gap-1 text-sm font-semibold
                          text-[#5b6f00] group-hover:gap-2.5 transition-all duration-200">
          Read article
          <span className="transition-transform duration-200 group-hover:translate-x-1">→</span>
        </span>
      </div>
    </button>
  );
};

export default BlogCard;
